<template>
    <v-container class="container" fluid>
        <template>
            <v-card>
                <v-card-title>
                    <v-toolbar dark color="secondary">
                        <v-spacer />
                        <v-toolbar-title class="white--text"
                            >Manual Readings</v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </v-card-title>
                <div class="pa-4">
                    <v-row>
                        <v-col cols="6">
                            <v-combobox
                                v-on:change="loadTankInformation"
                                v-model="stationID"
                                :items="stations"
                                :item-text="'Name'"
                                :item-value="'stations.id'"
                                label="Select a Station"
                                class="mx-3"
                                auto-select-first
                                solo
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <div class="text-center" v-if="loadData">
                        <v-progress-linear
                            :size="50"
                            color="primary"
                            indeterminate
                        ></v-progress-linear>
                    </div>
                    <template v-if="count != null">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-data-table
                                :headers="titles"
                                :items="tanks"
                                item-key="id"
                                key="i"
                                loading="dataLoading"
                                loading-text="Loading... Please wait"
                                hide-default-footer
                            >
                                <template v-slot:item.Volume="{ item }">
                                    <v-col cols="12">
                                        <v-text-field
                                            v-model="volume[item.Tank]"
                                            label="Enter Volume"
                                            :rules="[
                                                v =>
                                                    !!v || 'Volume is required',
                                                v =>
                                                    v <=
                                                        tanks[item.Tank - 1]
                                                            .SafeFill ||
                                                    'Do not exceed the capacity of the tank'
                                            ]"
                                            type="number"
                                            :input="
                                                calculateUllage(
                                                    item.Tank,
                                                    volume[item.Tank]
                                                )
                                            "
                                            solo
                                            required
                                        ></v-text-field>
                                    </v-col>
                                </template>

                                <template v-slot:item.Ullage="{ item }">
                                    <v-text-field
                                        v-model="ullage[item.Tank]"
                                        label="Calculating Ullage"
                                        type="number"
                                        solo
                                        disabled
                                        required
                                    ></v-text-field>
                                </template>

                                <template v-slot:item.InventaryDate="{ item }">
                                    <v-text-field
                                        label="Reading Date Time"
                                        :id="'StartTime' + item.Tank"
                                        v-mask="'####/##/## ##:##'"
                                        :rules="dateRules"
                                        type="tel"
                                        outlined
                                        dense
                                        solo
                                        required
                                    ></v-text-field>
                                </template>
                            </v-data-table>
                        </v-form>

                        <v-row justify="end">
                            <v-col cols="1">
                                <v-btn
                                    color="primary"
                                    class="mr-4"
                                    @click="validate()"
                                    >Submit</v-btn
                                >
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                    </template>
                </div>
            </v-card>
        </template>
        <v-bottom-sheet v-model="sheet">
            <v-sheet class="text-center" height="200px">
                <v-btn class="mt-6" text color="red" @click="sheet = !sheet"
                    >close</v-btn
                >
                <div class="py-3">
                    <strong class="primary--text">{{ message }}</strong>
                </div>
            </v-sheet>
        </v-bottom-sheet>
    </v-container>
</template>
<script>
import axios from 'axios';

import { mask } from 'vue-the-mask';
export default {
    directives: {
        mask
    },
    data: function() {
        return {
            titles: [
                { text: 'Station Number', value: 'StationNum', width: '7%' },
                { text: 'Tank Number', value: 'Tank', width: '10%' },
                { text: 'Product', value: 'Product', width: '15%' },
                { text: 'Volume', value: 'Volume', width: '23%' },
                { text: 'Capacity', value: 'SafeFill', width: '10%' },
                { text: 'Ullage', value: 'Ullage', width: '10%' },
                {
                    text: 'Reading Date Time',
                    value: 'InventaryDate',
                    width: '20%'
                }
            ],
            volumeRules: [v => !!v || 'Volume is required'],
            data: [],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            stations: [],
            tanks: [],
            stationID: null,
            count: null,
            volume: [],
            ullage: [],
            menu: [],
            menu2: [],
            dates: [],
            times: [],
            params: {},
            sheet: false,
            message: '',
            valid: true,
            loadData: false
        };
    },
    mounted() {
        this.loadStations();
    },
    methods: {
        loadStations: function() {
            this.$store.state.isLoading = true;
            axios
                .get('station/manual', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.stations = response.data.data;
                    console.log(this.stations);
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        loadTankInformation: function() {
            if(this.stationID != null){
            this.$store.state.isLoading = true;
            this.loadData = true;
            axios
                .get('tank/station/' + this.stationID.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.loadData = false;
                    this.resetArrays();
                    this.tanks = response.data.data;
                    console.log(this.tanks);
                    this.count = Object.keys(this.tanks).length;
                    for (let index = 0; index < this.count; index++) {
                        this.menu[index] = false;
                    }
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
                }
        },

        chargeReadings: function() {
            this.data.length = 0;
            this.params.length = 0;
            for (let index = 0; index < this.count; index++) {
                var ullage =
                    this.tanks[index].SafeFill - this.volume[index + 1];
                var arr = {
                    'Site #': String(this.tanks[index].StationNum),
                    'Inventory Date': this.getMsk('StartTime' + (index + 1)),
                    Volume: this.volume[index + 1],
                    Ullage: String(ullage),
                    'Tank #': String(this.tanks[index].Tank),
                    ReadingSourceID: '5'
                };
                this.data.push(arr);
            }
            console.log(this.data);
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },

        newReadings:async function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            await this.chargeReadings();
            var read = {
                readings: this.data
            };
            axios
                .put('ftp-readings/multiple/', read, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    str.dispatch('setSnackbar', {
                            color: 'success',
                            text:
                                'The operation was executed successfully'
                        });
                        this.tanks = [];
                        this.data = [];
                        this.stationID = null;
                        this.station = [];
                        this.loadStations();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                        str.state.isLoading = false;
                    }
                });
            this.$store.state.isLoading = false;
        },

        resetArrays: function() {
            this.volume.length = 0;
            this.dates.length = 0;
            this.menu.length = 0;
            this.menu2.length = 0;
            this.times.length = 0;
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.newReadings();
            }
        },
        calculateUllage: function(tank, vol) {
            if (vol < this.tanks[tank - 1].SafeFill) {
                this.ullage[tank] = this.tanks[tank - 1].SafeFill - vol;
            }
        }
    }
};
</script>
